var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPresentacion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29.236,
    height: 28.953,
    viewBox: "0 0 29.236 28.953",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #002e6b;\r\n      }\r\n\r\n      .cls-2 {\r\n        clip-path: url(#clip-path);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3658",
    "data-name": "Rectangle 3658",
    className: "cls-1",
    width: 29.236,
    height: 28.953
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4331",
    "data-name": "Group 4331",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4319",
    "data-name": "Group 4319",
    className: "cls-2",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7502",
    "data-name": "Path 7502",
    className: "cls-1",
    d: "M10.661,32.747H8.924V23.893H6.913v-8.2A3.189,3.189,0,0,1,10.1,12.5h5.627l4.848-4.75L21.789,9l-5.355,5.245H10.1A1.45,1.45,0,0,0,8.65,15.689v6.466h2.011Z",
    transform: "translate(-3.382 -3.794)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3657",
    "data-name": "Rectangle 3657",
    className: "cls-1",
    width: 1.737,
    height: 10.591,
    transform: "translate(9.359 18.363)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7503",
    "data-name": "Path 7503",
    className: "cls-1",
    d: "M14.068,6.2A2.317,2.317,0,1,0,16.384,8.52,2.316,2.316,0,0,0,14.068,6.2m0,2.9a.579.579,0,1,1,.579-.579.58.58,0,0,1-.579.579",
    transform: "translate(-5.748 -3.035)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7504",
    "data-name": "Path 7504",
    className: "cls-1",
    d: "M47.158,50.643H45.421v-3.12a1.45,1.45,0,0,0-1.448-1.448H39.821a1.45,1.45,0,0,0-1.448,1.448v3.12H36.636v-3.12a3.189,3.189,0,0,1,3.185-3.185h4.152a3.189,3.189,0,0,1,3.185,3.185Z",
    transform: "translate(-17.922 -21.69)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7505",
    "data-name": "Path 7505",
    className: "cls-1",
    d: "M44.578,35.344a.724.724,0,1,1-.724.724.725.725,0,0,1,.724-.724m0-1.738a2.462,2.462,0,1,0,2.462,2.462,2.462,2.462,0,0,0-2.462-2.462",
    transform: "translate(-20.603 -16.44)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7506",
    "data-name": "Path 7506",
    className: "cls-1",
    d: "M1.737,15.3H0V0H28.968V15.291H13.054V13.554H27.231V1.737H1.737Z",
    transform: "translate(0 0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPresentacion);
export default __webpack_public_path__ + "static/media/Icon_Presentacion.f167a38e3f1cfd26de9d476f10fabbe6.svg";
export { ForwardRef as ReactComponent };